import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      "banner_title": "Get ready for Take off",
      "banner-title_ae": "Proud of UAE",
      "banner_title_sa": "Saudi Arabia Awaits You",
      "banner_title_qa": "Your Window to the World",
      "banner_title_om": "Oman: A Legacy of Trade, A Future of Partnership",
      "banner_title_kwt": "Kuwait: Where Tradition Meets Modernity",
      "banner_title_bah": "Bahrain: Where the World Meets the Future",
      "banner_subtitle": "Millions of cheap flights. One simple search. The best deals anywhere!",
      "banner-subtitle_ae": "Your Gateway to the World, Rooted in the UAE!",
      "banner-subtitle_sa": "Where the World Meets the Future!",
      "banner-subtitle_qa": "Anchored in the Heart of Qatar!",
      "banner-subtitle_om": "Your Gateway to the World, Rooted in Oman!",
      "banner-subtitle_kwt": "A Legacy of Trade, Rooted in the Heart of the Gulf!",
      "banner-subtitle_bah": "Discover the Island Where the World Connects!",
      "one_way": "One Way",
      "round_trip": "Round Trip",
      "from": "From",
      "to": "To",
      "search_flights": "Search Flights",
      "departure": "Departure",
      "return": "Return",
      "origin": "Origin",
      "destination": "Destination",
      "travelers": "Traveller(s)",
      "class": "Class",
      "select_class": "Select Class",
      "adult": "Adult (12+)",
      "child": "Child (2-11)",
      "infant": "Infant(Below 2yrs)",
      "search_btn": "Search Flights",
      "economy": "Economy",
      "standard_economy": "Standard Economy",
      "premium_economy": "Premium Economy",
      "business": "Business",
      "premium_business": "Premium Business",
      "first_class": "First Class",
      "premium_first_class": "Premium First Class",
      "flights": "Flights",
      "visa": "Visa",
      "forex": "Forex",
      "umrah": "Umrah",
      "holidays": "Holidays",
      "attestation": "Attestation",
      "passport": "Consular Services",
      "welcome": "Welcome to alhind!",
      "login": "Login",
      "sign_in": "Sign in",
      "sign_in_caption": "Sign in to explore flights, holidays & more",
      "more": "More",
      "sign_deal1": "Exclusive member deals",
      "sign_deal2": "Instant booking confirmations",
      "sign_deal3": "Manage trips with ease",
      "enter_mobile": "Enter Mobile Number",
      "email_mobile": "Email or Mobile",
      "email": "Email",
      "enter_email": "Enter your email",
      "mobile_number": "Enter your mobile number",
      "mobile": "Mobile Number",
      "otp_verification": "OTP Verification",
      "otp": "One-Time Password",
      "otp_sent_to_email": "An OTP has been sent to your email",
      "sent_to": "Sent to",
      "resend_otp": "Resend OTP",
      "by_continuing": "By continuing, you agree to our",
      "already_have_account": "Already have an account? Sign In",
      "submit": "Submit",
      "continue": "Continue",
      "recent_searches": "Recent Searches",
      "my_profile": "My Profile",
      "my_trips": "My Trips",
      "logout": "Logout",
      "manage_account": "Manage Account",
      //Search Results page
      "filters": "Filters",
      "airlines": "Airlines",
      "stops": "Stops",
      "departure_time": "Departure Time",
      "arrival_time": "Arrival Time",
      "oneway_pricing": "One Way Pricing",
      "cheapest": "Cheapest",
      "fastest": "Fastest",
      "earliest": "Earliest",
      "reset_filters": "Reset filters",
      "travel_and_class": "Traveller & Class",
      "modify": "MODIFY",
      "book": "BOOK",
      "price": "Price",
      "onward": "Onward",
      "nonrefundable": "Non-refundable",
   
      "more_fares": "More Fares",
      "flight_details": "Flight Details",
      "non_stop": "Non-stop",
      "stop": "Stop",
      "seats": "Seats",
      "hrs": "Hrs",
      "min": "Min",
      "onward_price": "Onward Price",
      "return_price": "Return Price",
      "am": "AM",
      "pm": "PM",
      "fare_summary": "Fare Summary",
      "baggage": "Baggage",
      "type": "Type",
      "base_fare": "Base Fare",
      "fees_tax": "Fees & Tax",
      "adults": "Adults",
      "child1": "Child",
      "infant1": "Infant",
      "convinience": "Convenience Fee",
      "total": "Total",
      "book_conditions": "All fares & seats are subject to availability at the time of booking",
      "checkin": "Check-in",
      "cabin": "Cabin",
      "book_info": "The information is just for reference. Please check with airline before check-in",
      "after": "After",
      "before": "Before", 
      "one_way_price": "One Way Price",

      //Pax Data Collection page
      "traveller_details": "Traveller Details",
      "passport_details": "Passport Details",
      "first_name": "First Name",
      "enter_first_name": "Enter First Name",
      "last_name": "Last Name",
      "enter_last_name": "Enter Last Name",
      "passport_number": "Passport Number",
      "enter_passport_number": "Enter Passport Number",
      "nationality": "Nationality",
      "date_of_birth": "Date of Birth",
      "country_of_issue": "Country of Issue",
      "date_of_expiry": "Date of Expiry",
      "traveller_contact": "Traveller Contact",
      "ticket_flight_info": "Your ticket and flight info will be sent here",
      "price_summary": "Price Summary",
      "view_fare_rules": "View Fare Rules",
      "fare_rules": "Fare Rules",
      "taxes_fees": "Taxes & Fees",
      "convenience_fee": "Convenience Fee",
      "addons": "Add-ons",
      "total_fare": "Total Fare",
      "discount": "Discount",
      "you_pay": "You Pay",
      "have_promo": "Have a promo code?",
      "your_promo_code": "Your promo code",
      "apply": "APPLY",
      "title": "Title",
      "mr": "Mr",
      "ms": "Ms",
      "mrs": "Mrs",
      "mstr": "Mstr",
      "miss": "Miss",
      "minutes_left": "minutes left to complete the booking",
      "contact_number": "Contact Number",
      "alternate_contact_number": "Alternate Contact Number",
      "are_you_sure": "Are you sure you want to continue the booking",
      "yes": "YES",
      "cancel": "CANCEL",
      "please_wait": "Please wait...",
      "important_info": "Important Information",

      //Payment page
      "make_payment": "Make Payment",
      "amount_to_pay": "Amount to Pay",
      "credit_card": "Credit Card",
      "credit_carddebit_card": "Credit/Debit Card",
      "tabby": "Tabby",
      "mada_card": "Mada Card",
      "pay_with_credit_card": "Pay with Credit Card",
      "pay_with_credit_card_debit_card": "Pay with Credit/Debit Card",
      "pay_with_tabby": "Pay with Tabby",
      "pay_with_mada_card": "Pay with Mada Card",
      "understand": "I understand and agree to the Fare rules, the Privacy Policy, the User Agreement and the Terms and Conditions of alhind.",
      "pay_now": "Pay Now",
      "cost": "Cost",
      "grand_total": "Grand Total",
      "special_offer": "Special Offer",
      "we_have_applied": "We have applied a special offer for you",
      "tax": "Tax",

     //Booking Confirmation page
     





      "why_alhind": "Why alhind?",
      "why_alh1": "Assured Best Rates",
      "why_alh2": "One Stop Travel Services",
      "why_alh3": "Instant Deals on Flights",
      "why_alh4": "24 x 7 Customer Support",
      "why_desc1": "Find lowest possible prices to destinations",
      "why_desc2": "All your booking needs handled in one place",
      "why_desc3": "Grab the best curated deals from us",
      "why_desc4": "We are happy to assist you anytime",
      "alh_header": "Search Flights, Hotels, Bus and Holiday Packages",
      "alh_desc": "Headquartered in Calicut (Kozhikode), Kerala, the Alhind Group has established itself as a global powerhouse in the travel and tourism sector. With a remarkable turnover exceeding 20,000 crore, the group operates an extensive network across India and the GCC countries. From its roots as a regional agency, it has successfully diversified into a massive conglomerate, leveraging its local expertise to dominate international markets.",
      "vertical_header": "Our Business Verticals",
      "show_less": "Show Less",
      "view_all_verticals": "View All Verticals",
      "useful_links": "Useful Links",
      "about_us": "About us",
      "disclaimer": "Disclaimer",
      "privacy_policy": "Privacy Policy",
      "terms_of_use": "Terms of Use",
      "services": "Services",
      "connect_us": "Connect us",
      "copyright": "Copyright © 2026, Alhind all rights reserved.",
      "hotel": "Hotel",
      "insurance": "Insurance",
      //Disclaimer, Privacy Policy and Terms of Use contents.
       "disclaimer_title": "Disclaimer",
       "disclaimer_p1": "The information contained in this Web Site is only for general information about Alhind Tours & Travels Pvt. Ltd., its subsidiaries and associates (here in after referred to as 'alhind') and the services that they offer and is not in any way binding on alhind...",
       "disclaimer_p2": "Alhind hereby excludes any warranty (either express or implied) as to the correctness, completeness, timeliness, accuracy, fitness for a particular purpose of the Web Site or any of its contents.",
       "disclaimer_p3": "By accessing this Web Site you agree that alhind will not be liable for any direct or indirect or consequential loss...",
       "disclaimer_p4": "The carrying of passengers, baggage and cargo by air will be subject to the conditions of carriage...",
       "disclaimer_p5": "Unless otherwise stated, copyright or similar rights in all material contained in this Web Site is owned by alhind...",
       "disclaimer_policy_title": "Cancellation / Refund / Reissuance of ticket policy",
       "disclaimer_policy_desc": "Guests are requested to contact the carrier for more information on the policy.",

       "privacy_title": "Privacy Policy",
       "privacy_intro": "We understand that making purchases online involves a great deal of trust on your part. We take this trust very seriously, and make it our highest priority to ensure the security and confidentiality of the personal information you provide to us. Please read the following policy to learn about our privacy practices",
       "privacy_collect_title": "What information we collect from you?",
       "privacy_collect_general": "General: We receive and store any information you enter on our Website or give us in any other way. This includes information that can identify you (personal information), including your first and last name, telephone number, postal and e-mail addresses, contact details and, in some cases, billing information (such as credit card number, cardholder name, and expiration date). We also may request information about your traveler preferences, including meal requests, seat selection, frequent flyer/hotel/car rental program information, and ticketing options. You can choose not to provide information to us, but in general some information about you is required in order for you to register as a member; purchase products or services; complete a traveler profile; participate in a survey, contest, or promotions; or initiate other transactions on our site.",
       "privacy_pax_info" : "Passenger Information: When you make travel or other arrangements for someone else through the Website , we will request personal information and travel preferences about that individual. You should obtain the consent of other individuals prior to providing the Website with their personal information and travel preferences, as any access to view or change their information will be available only through your account.",
        "privacy_info_other_sources": "Information from Other Sources: We also may periodically obtain information about you from our business partners and other independent third-party sources and add it to our account information. Examples of information we may receive include: updated delivery and address information, which we use to correct our records and to facilitate proper delivery of travel information; and demographic information, which we use to better understand your potential purchasing preferences.",
        
       "privacy_how_use_title": "How we use your information",
       "privacy_use_list": [
        "To provide you with the products and services you request;",
        "To provide you with travel confirmation and updates;"
    ],
    "link_text": "Link",
    //Visa page
    "visa_title": "Visa Services",
    "visa_subtitle1": "Getting a Visa is Simple",
    "visa_subtitle2": "with",
    "visa_subtitle3": "alhind!",
    "visa_subtitle4": "Search your destination country and get started in minutes",
     "visa_subtitle5": "50,000+ Applicants",
     "visa_subtitle6": "98% Approval Rate",
   "visa_subtitle7": "24/7 Support",
   "visa_subtitle8": "150+ Branches",
   "explore": "Explore",
   "v_dest_title": "Popular Visa Assistance Destinations",
   "v_dest_desc": "Since a visa is the sole document that has the power to make or break your travel arrangements, our dedicated Visa department provides expert services that guarantee your Visa arrives on time.",
 "why_choose_alhind_visa": "Why choose us?",
 "how_it_works": "How it works?",
 "visa_step_header": "Visa Processing — 3 Simple Steps",
 "visa_step1": "Submit Documents",
  "visa_step2": "Verify &amp; Process",
  "visa_step3": "Receive Your Visa",
  "visa_step1_desc": "Submit your passport, photos &amp; supporting documents",
  "visa_step2_desc": "Our experts review & submit your application to the embassy",
  "visa_step3_desc": "Get your approved visa delivered to your inbox or doorstep",
  "trusted_by": "Trusted by over 50,000 applicants with a 98% approval rate",
"visa_features": {
      "services": "Visa Services for all Countries",
      "experience": "25 years of experience in Visa processing",
      "branches": "150+ Branches Worldwide",
      "assistance": "End-to-End Visa Assistance",
      "delivery": "Pick Up & Drop of Documents",
      "safety": "Safety & Confidentiality",
    },

    //Visa Details
   "visa_price_start": "Price starting at",
    "types_of": "Types of",
    "visa_d": "Visa",
    "processing_time": "Processing Time:",
    "days": "days",
    "upto": "Upto",
    "stay_period": "Stay period:",
    "validity": "Validity:",
    "entry": "Entry:",
    "fees": "Fees:",
    "contact_us": "Contact Us",
    "req_doc_btn": "Required Documents",
    "embassy_details": "Embassy Details",
    "notes": "Notes",
    "enquiry_title": "Fill the Form to Submit an Enquiry",
    "full_name": "Full Name*",
    "email_id": "Email ID*",
    "mobile_no": "Mobile No.*",
    "select_visa": "Select One Visa Option",
    "submit_v": "SUBMIT",
    "need_help": "Need Help?",
    "help_desc": "Our Visa expert will be happy to help you resolve your queries.",
    "error_fill_all": "Fill All Fields",




//Forex page
"buy_forex": "Buy Forex",
"sell_forex": "Sell Forex",
"select_city": "Select City",
"select_currency": "Select Currency",
"currency_you_want": "Currency You want",
"amount": "Total Amount",
"choose_currency": "Choose Currency",
"forex_slider_title1": "Buy & Sell Foreign Currency Notes at Best Rates with alhind",
"forex_slider_desc1": "Guaranteed Best Rates in Market",
"forex_slider_title2": "Genuine currency notes from verified RBI-licensed companies",
"forex_slider_desc2": "Guaranteed Best Rates in Market",
"forex_slider_title3": "Best rates compared across hundreds of money changers",
"forex_slider_desc3": "Guaranteed Best Rates in Market",
"buy": "Buy",
"sell": "Sell",
"rate_card_button": "View Full Rate Card",
"rate_card_title": "Forex Rate Card",
"currency": "Currency",
"buy_rate": "Buy Rate",
"sell_rate": "Sell Rate",
"close": "Close",
"about_alhind_forex": "About alhind Forex",
"alhind_forex_desc": "We are approved by the Reserve Bank of India to operate as a Full Fledged Money Changer.",
"branches": "Branches all over india",
"customers": "Satisfied Customers",
"legacy": "Years of Legacy",
"safe_money": "Your Money is Safe",
"location_required": "Location required",
"currency_required": "Currency required",
"quantity_required": "Quantity required",
//Profile Page
"my_account": "My Account",
"profile": "Profile",
"my_transactions": "My Transactions",
"delete_account": "Delete my account",
"personal_info": "Personal Informations",
"profile_desc": "Basic info, for a faster booking experience",
"edit": "Edit",
"country": "Country",
"state": "State",
"city": "City",
"pincode": "Pincode",
"address": "Address",


      "verticals": {
        "alhind_com": {
          "title": "alhind.com",
          "desc": "The backbone of the group, offering core travel and tour services including tickets, bookings, and corporate travel management."
        },
        "dhanhind": {
          "title": "Dhanhind",
          "desc": "A tech-driven B2B platform that integrates travel services with financial solutions."
        },
        "umrah": {
          "title": "Hajj & Umrah",
          "desc": "Specialized, comprehensive pilgrimage services for the spiritual traveler."
        },
        "holidays": {
          "title": "alhind Holidays",
          "desc": "Curated holiday packages and diverse travel products designed for global tourism."
        },
        "alhind_air": {
          "title": "alhind Air",
          "desc": "The group's ambitious new venture into the airline industry."
        },
        "alhind_exchange": {
          "title": "alhind Exchange",
          "desc": "Professional foreign currency exchange services for international travelers."
        },
        "alhind_soft": {
          "title": "alhind Soft",
          "desc": "The technology arm, developing specialized travel tech and software solutions."
        },
        "alhind_academy": {
          "title": "alhind Academy",
          "desc": "A dedicated training institute for travel, tourism, and aviation professionals."
        },
        "alhind_study_abroad": {
          "title": "alhind Study Abroad",
          "desc": "Expert overseas education consultancy for students aspiring to study globally."
        },
        "alhind_bus": {
          "title": "alhind Bus",
          "desc": "Luxury bus travel operations connecting major routes."
        },
        "alhind_wheels": {
          "title": "alhind Wheels",
          "desc": "Premium car and coach rental services for localized travel."
        },
        "avs_world": {
          "title": "AVS World",
          "desc": "A dedicated visa processing service ensuring seamless international documentation."
        },
        "alhind_attestation": {
          "title": "alhind Attestation",
          "desc": "Reliable document attestation services for legal and professional needs."
        },
        "alhind_charitable_foundation": {
          "title": "alhind Charitable Foundation",
          "desc": "The group's CSR wing, focusing on community development and social welfare."
        },
        "alhind_calicut_tower": {
          "title": "alhind Calicut Tower",
          "desc": "The group's flagship in hotel and hospitality services located in Kerala."
        },
        "alhind_aqua": {
          "title": "alhind Aqua",
          "desc": "The group's consumer vertical, featuring its own mineral water brand."
        },
          "alhind_jobs": {
          "title": "alhind Jobs",
          "desc": "Global recruitment and placement solutions connecting talent with international opportunities."
        }

      }
    }
  },
  ar: {
    translation: {
      "banner_title": "استعد للإقلاع",
      "banner-title_ae": "فخورون بالإمارات",
      "banner_title_sa": "المملكة العربية السعودية في انتظارك",
      "banner_title_qa": "نافذتك إلى العالم",
      "banner_title_om": "عمان: إرث من التجارة، مستقبل من الشراكة",
      "banner_title_kwt": "الكويت: حيث يلتقي التقليد بالحداثة",
      "banner_title_bah": "البحرين: حيث يلتقي العالم بالمستقبل",
      "banner_subtitle": "ملايين الرحلات الجوية الرخيصة. بحث بسيط واحد. أفضل العروض في أي مكان!",
      "banner-subtitle_ae": "بوابتك إلى العالم، متجذرة في الإمارات!",
      "banner-subtitle_sa": "المملكة العربية السعودية في انتظارك",
      "banner-subtitle_qa": "نافذتك إلى العالمراسخ في قلب قطر!",
      "banner-subtitle_om": "بوابتك إلى العالم، متجذرة في عمان!",
      "banner-subtitle_kwt": "إرث من التجارة، متجذر في قلب الخليج!",
      "banner-subtitle_bah": "اكتشف الجزيرة حيث يلتقي العالم!",
      
      "one_way": "ذهاب فقط",
      "round_trip": "ذهاب وعودة",
      "from": "من",
      "to": "إلى",
      "search_flights": "بحث عن رحلات",
      "departure": "المغادرة",
      "return": "العودة",
      "origin": "الأصل",
      "destination": "الوجهة",
      "travelers": "المسافرون",
      "class": "الفئة",
      "select_class": "اختر الفئة",
      "adult": "بالغ (12+)",
      "child": "طفل (2-11)",
      "infant": "رضيع (تحت 2 سنة)",
      "search_btn": "بحث عن رحلات",
      "economy": "اقتصادية",
      "standard_economy": "اقتصادية قياسية",
      "premium_economy": "اقتصادية مميزة",
      "business": "رجال الأعمال",
      "premium_business": "رجال الأعمال المميزة",
      "first_class": "الدرجة الأولى",
      "premium_first_class": "الدرجة الأولى المميزة",
      "flights": "رحلات",
      "visa": "تأشيرة",
      "forex": "صرف العملات",
      "umrah": "عمرة",
      "holidays": "عطلات",
      "attestation": "التصديق",
        "passport": "الخدمات القنصلية",
        "welcome": "مرحبًا بك في الهند!",
      "login": "تسجيل الدخول",
      "sign_in": "تسجيل الدخول",
      "sign_in_caption": "سجل الدخول لاستكشاف الرحلات الجوية والعطلات والمزيد",
      "more": "المزيد",
      "sign_deal1": "عروض حصرية للأعضاء",
      "sign_deal2": "تأكيدات الحجز الفورية",
      "sign_deal3": "إدارة الرحلات بسهولة",
        "enter_mobile": "أدخل رقم الهاتف المحمول",
      "email_mobile": "البريد الإلكتروني أو الهاتف المحمول",
      "email": "البريد الإلكتروني",
      "enter_email": "أدخل بريدك الإلكتروني",
        "mobile_number": "أدخل رقم هاتفك المحمول",

      "mobile": "رقم الهاتف المحمول",
      "otp_verification": "التحقق من OTP",
      "otp": "كلمة المرور لمرة واحدة",
      "otp_sent_to_email": "تم إرسال OTP إلى بريدك الإلكتروني",
      "sent_to": "أرسل إلى",
      "resend_otp": "إعادة إرسال OTP",
      "by_continuing": "بالمتابعة، فإنك توافق على",
        "already_have_account": "هل لديك حساب؟ تسجيل الدخول",
        
      "submit": "إرسال",
      "continue": "استمر",
      "recent_searches": "عمليات البحث الأخيرة",
      "my_profile": "ملفي الشخصي",
      "my_trips": "رحلاتي",
      "logout": "تسجيل خروج",
      "manage_account": "إدارة الحساب",
       //Search Results page
      "filters": "الفلاتر",
        "airlines": "شركات الطيران",
        "stops": "التوقفات",
        "departure_time": "وقت المغادرة",
        "arrival_time": "وقت الوصول",
        "oneway_pricing": "السعر لرحلة الذهاب فقط",
        "cheapest": "الأكثر اقتصاداً",
        "fastest": "الأسرع",
        "earliest": "الأبكر",
      "reset_filters": "إعادة تعيين الفلاتر",
        "travel_and_class": "المسافر والفئة",
        "modify": "تعديل",
        "book": "حجز",
        "price": "السعر",
        "onward": "الذهاب",
        "nonrefundable": "غير قابل للاسترداد",
        
        "more_fares": "المزيد من الأسعار",
        "flight_details": "تفاصيل الرحلة",
          "non_stop": "مباشرة",
          "stop": "توقف",
            "seats": "المقاعد",
            "hrs": "ساعات",
            "min": "دقائق",
              "onward_price": "سعر الذهاب",
              "return_price": "سعر العودة",
      "am": "صباحا",
      "pm": "ظهرا",
      "fare_summary": "ملخص الأجرة",
      "baggage": "الأمتعة",
        "type": "النوع",
        "base_fare": "الأجرة الأساسية",
        "fees_tax": "الرسوم والضرائب",
        "adults": "البالغين",
        "child1": "طفل",
        "infant1": "رضيع",
        "convinience": "رسوم الخدمة",
        "total": "المجموع",
        "book_conditions": "جميع الأسعار والمقاعد تخضع للتوفر في وقت الحجز",
        "book_info": "المعلومات مقدمة فقط لأغراض مرجعية. يرجى التحقق من شركة الطيران قبل تسجيل الوصول",
        "after": "بعد",
        "before": "قبل",
        "one_way_price": "سعر رحلة الذهاب فقط",
        //Pax Data Collection page
        "traveller_details": "تفاصيل المسافر",
        "passport_details": "تفاصيل جواز السفر",
        "first_name": "الاسم الأول",
        "enter_first_name": "أدخل الاسم الأول",
        "last_name": "اسم العائلة",
        "enter_last_name": "أدخل اسم العائلة",
        "passport_number": "رقم جواز السفر",
        "enter_passport_number": "أدخل رقم جواز السفر",
        "nationality": "الجنسية",
        "date_of_birth": "تاريخ الميلاد",
        "country_of_issue": "بلد الإصدار",
        "date_of_expiry": "تاريخ الانتهاء",
        "traveller_contact": "معلومات الاتصال بالمسافر",
        "ticket_flight_info": "سيتم إرسال معلومات تذكرتك ورحلتك هنا",
        "price_summary": "ملخص السعر",
        "view_fare_rules": "عرض قواعد الأجرة",
        "taxes_fees": "الضرائب والرسوم",
        "convenience_fee": "رسوم الخدمة",
        "addons": "الإضافات",
        "total_fare": "الأجرة الإجمالية",
        "discount": "الخصم",
        "you_pay": "أنت تدفع",
        "have_promo": "هل لديك رمز ترويجي؟",
        "your_promo_code": "رمزك الترويجي",
        "apply": "تطبيق",
        "title": "اللقب",
        "mr": "السيد",
        "ms": "الآنسة",
        "mrs": "السيدة",
        "minutes_left": "دقائق متبقية لإكمال الحجز",
        "contact_number": "رقم الاتصال",
        "alternate_contact_number": "رقم الاتصال البديل",
        "are_you_sure": "هل أنت متأكد أنك تريد متابعة الحجز؟",
      "yes": "نعم",
      "cancel": "إلغاء",
      "please_wait": "يرجى الانتظار...",
      "important_info": "معلومات مهمة",
      //Payment page
      "make_payment": "قم بالدفع",
      "amount_to_pay": "المبلغ الذي يجب دفعه",
      "credit_card": "بطاقة الائتمان",
      "tabby": "تابي",
      "mada_card": "بطاقة مدى",
      "pay_with_credit_card": "الدفع باستخدام بطاقة الائتمان",
      "pay_with_tabby": "الدفع باستخدام تابي",
      "pay_with_mada_card": "الدفع باستخدام بطاقة مدى",
      "understand": "أنا أفهم وأوافق على قواعد الأجرة، سياسة الخصوصية، اتفاقية المستخدم وشروط وأحكام الهند.",
      "pay_now": "ادفع الآن",
      "cost": "التكلفة",
      "grand_total": "المجموع الكلي",
      "special_offer": "عرض خاص",
      "we_have_applied": "لقد طبقنا عرضًا خاصًا لك",
      "tax": "الضريبة",




        
      "why_alhind": "ألهند.كوم لماذا؟",
      "why_alh1": "أفضل الأسعار المضمونة",
      "why_alh2": "خدمات السفر الشاملة",
      "why_alh3": "عروض فورية على الرحلات",
      "why_alh4": "دعم العملاء 24 × 7",
      "why_desc1": "اعثر على أقل الأسعار الممكنة إلى الوجهات",
      "why_desc2": "جميع احتياجات الحجز الخاصة بك يتم التعامل معها في مكان واحد",
      "why_desc3": "احصل على أفضل العروض المختارة منا",
      "why_desc4": "يسعدنا مساعدتك في أي وقت",
      "alh_header": "ابحث عن رحلات، فنادق، حافلات وباقات العطلات",
      "alh_desc": "يقع المقر الرئيسي لمجموعة الهند في كاليكوت (كوزيكود)، كيرالا، وقد أثبتت نفسها كقوة عالمية في قطاع السفر والسياحة. مع دوران مذهل يتجاوز 20,000 كرور، تدير المجموعة شبكة واسعة عبر الهند ودول مجلس التعاون الخليجي. من جذورها كوكالة إقليمية، نجحت في التنويع إلى تكتل ضخم، مستفيدة من خبرتها المحلية للهيمنة على الأسواق الدولية.",
      "vertical_header": "قطاعات أعمالنا",
      "show_less": "عرض أقل",
      "view_all_verticals": "عرض جميع القطاعات",
      "useful_links": "روابط مفيدة",
      "about_us": "معلومات عنا",
      "disclaimer": "إخلاء المسؤولية",
      "privacy_policy": "سياسة الخصوصية",
      "terms_of_use": "شروط الاستخدام",
      "services": "خدماتنا",
      "connect_us": "اتصل بنا",
      "copyright": "حقوق الطبع والنشر © 2026 ، الهند. جميع الحقوق محفوظة.",
      "hotel": "فنادق",
      "insurance": "تأمين",
      //Disclaimer, Privacy Policy and Terms of Use contents.
      "disclaimer_title": "إخلاء المسؤولية",
      "disclaimer_p1": "المعلومات الواردة في هذا الموقع هي فقط للحصول على معلومات عامة عن شركة الهند للسياحة والسفر ذ.م.م، والشركات التابعة لها والزميلة (المشار إليها فيما يلي بـ 'الهند') والخدمات التي تقدمها وهي ليست ملزمة بأي حال من الأحوال...",
      "disclaimer_p2": "تستبعد شركة الهند بموجب هذا أي ضمان (سواء كان صريحًا أو ضمنيًا) فيما يتعلق بصحة أو اكتمال أو دقة محتويات الموقع.",
      "disclaimer_p3": "من خلال الدخول إلى هذا الموقع، فإنك توافق على أن الهند لن تكون مسؤولة عن أي خسارة مباشرة أو غير مباشرة أو تبعية...",
      "disclaimer_p4": "يخضع نقل الركاب والأمتعة والبضائع عن طريق الجو لشروط النقل واللوائح الخاصة بشركات الطيران المعنية...",
      "disclaimer_p5": "ما لم ينص على خلاف ذلك، فإن حقوق الطبع والنشر أو الحقوق المماثلة في جميع المواد الواردة في هذا الموقع مملوكة لشركة الهند...",
      "disclaimer_policy_title": "سياسة إلغاء / استرداد / إعادة إصدار التذاكر",
      "disclaimer_policy_desc": "يُرجى من الضيوف الاتصال بشركة الطيران للحصول على مزيد من المعلومات حول السياسة.",
      //Visa page
      "visa_title": "خدمات التأشيرات",
      "visa_subtitle1": "الحصول على تأشيرة بسيط",
      "visa_subtitle2": "مع",
      "visa_subtitle3": "الهند!",
      "visa_subtitle4": "ابحث عن بلد وجهتك وابدأ في دقائق", 
      "visa_subtitle5": "أكثر من 50,000 متقدم",
      "visa_subtitle6": "معدل الموافقة 98%",
      "visa_subtitle7": "دعم 24/7", 
      "visa_subtitle8": "أكثر من 150 فرعًا",
      "explore": "استكشف",
      "v_dest_title": "وجهات مساعدة التأشيرة الشعبية",
      "v_dest_desc": "نظرًا لأن التأشيرة هي الوثيقة الوحيدة التي لها القدرة على جعل أو كسر ترتيبات سفرك، فإن قسم التأشيرات المخصص لدينا يقدم خدمات خبراء تضمن وصول تأشيرتك في الوقت المحدد.",    
      "why_choose_alhind_visa": "لماذا تختارنا؟",
      "how_it_works": "كيف تعمل؟",
      "visa_step_header": "معالجة التأشيرة - 3 خطوات بسيطة",
      "visa_step1": "تقديم المستندات",
      "visa_step2": "التحقق والمعالجة", 
      "visa_step3": "استلم تأشيرتك",
      "visa_step1_desc": "قدم جواز سفرك وصورك والمستندات الداعمة",
      "visa_step2_desc": "يقوم خبراؤنا بمراجعة طلبك وتقديمه إلى السفارة",
      "visa_step3_desc": "احصل على تأشيرتك المعتمدة التي يتم تسليمها إلى بريدك الإلكتروني أو باب منزلك",
      "trusted_by": "موثوق به من قبل أكثر من 50,000 متقدم مع معدل موافقة 98%",
      "visa_features": {
      "services": "خدمات التأشيرات لجميع الدول",
      "experience": "25 عاماً من الخبرة في معالجة التأشيرات",
      "branches": "+150 فرعاً حول العالم",
      "assistance": "مساعدة شاملة في الحصول على التأشيرة",
      "delivery": "استلام وتسليم المستندات",
      "safety": "الأمان والسرية",
      
    },
      "visa_price_start": "السعر يبدأ من",
     "types_of": "أنواع",
"visa_d": "تأشيرة",
    "processing_time": "وقت المعالجة:",
    "days": "أيام",
    "upto": "حتى",
    "stay_period": "مدة الإقامة:",
    "validity": "الصلاحية:",
    "entry": "الدخول:",
    "fees": "الرسوم:",
    "contact_us": "اتصل بنا",
    "req_doc_btn": "المستندات المطلوبة",
    "embassy_details": "تفاصيل السفارة",
    "notes": "ملاحظات",
    "enquiry_title": "املأ النموذج لإرسال استفسار",
    "full_name": "الاسم الكامل*",
    "email_id": "البريد الإلكتروني*",
    "mobile_no": "رقم الجوال*",
    "select_visa": "اختر نوع التأشيرة",
    "submit_v": "إرسال",
    "need_help": "تحتاج مساعدة؟",
    "help_desc": "سيسعد خبير التأشيرات لدينا بمساعدتك في حل استفساراتك.",
    "error_fill_all": "يرجى ملء جميع الحقول",
//Forex page
"buy_forex": "شراء الفوركس",
"sell_forex": "بيع الفوركس",
"select_city": "اختر المدينة",
"select_currency": "اختر العملة",
"currency_you_want": "العملة التي تريدها",
"amount": "المبلغ الإجمالي",
"choose_currency": "اختر العملة",
"forex_slider_title1": "شراء وبيع العملات الأجنبية بأفضل الأسعار مع الهند",
"forex_slider_desc1": "أفضل الأسعار المضمونة في السوق",
"forex_slider_title2": "أوراق نقدية أصلية من شركات مرخصة من RBI",
"forex_slider_desc2": "أفضل الأسعار المضمونة في السوق",
"forex_slider_title3": "أفضل الأسعار مقارنة عبر مئات من صرافين العملات",
"forex_slider_desc3": "أفضل الأسعار المضمونة في السوق",
"buy": "شراء",
"sell": "بيع",
"rate_card_button": "عرض بطاقة الأسعار الكاملة",
"rate_card_title": "بطاقة أسعار الفوركس",
"currency": "العملة",
"buy_rate": "سعر الشراء",
"sell_rate": "سعر البيع",
"close": "إغلاق",
"about_alhind_forex": "حول الهند فوركس",
"alhind_forex_desc": "نحن معتمدون من قبل بنك الاحتياطي الهندي للعمل كصراف عملات كامل.", 
"branches": "فروع في جميع أنحاء الهند",
"customers": "عملاء راضون",
"legacy": "سنوات من الإرث",
"safe_money": "أموالك في أمان",
"location_required": "الموقع مطلوب",
"currency_required": "العملة المطلوبة",
"quantity_required": "الكمية المطلوبة",

//Profile Page
// Profile Page
"my_account": "حسابي",
"profile": "الملف الشخصي",
"my_transactions": "معاملاتي",
"delete_account": "حذف حسابي",
"personal_info": "معلومات شخصية",
"profile_desc": "معلومات أساسية، لتجربة حجز أسرع",
"edit": "تعديل",
"country": "الدولة",
"state": "الولاية",
"city": "المدينة",
"pincode": "الرمز البريدي",
"address": "العنوان",
      
      "verticals": {
        "alhind_com": {
          "title": "ألهند.كوم",
          "desc": "العمود الفقري للمجموعة، يقدم خدمات السفر والجولات الأساسية بما في ذلك التذاكر والحجوزات وإدارة سفر الشركات."
        },
        "dhanhind": {
          "title": "دانهيند",
          "desc": "منصة B2B تقنية تدمج خدمات السفر مع الحلول المالية."
        },
        "umrah": {
          "title": "الحج والعمرة",
          "desc": "خدمات حج وعمرة متخصصة وشاملة للمسافر الروحي."
        },
        "holidays": {
          "title": "alhind للعطلات",
          "desc": "باقات عطلات مختارة ومنتجات سفر متنوعة مصممة للسياحة العالمية."
        },
        "alhind_air": {
          "title": "alhind Air",
          "desc": "مشروع المجموعة الطموح الجديد في صناعة الطيران."
        },
        "alhind_exchange": {
          "title": "الهند للصرافة",
          "desc": "خدمات صرف العملات الأجنبية الاحترافية للمسافرين الدوليين."
        },
        "alhind_soft": {
          "title": "alhind Soft",
          "desc": "الذراع التكنولوجية، تطوير تقنية السفر المتخصصة وحلول البرمجيات."
        },
        "alhind_academy": {
          "title": "أكاديمية الهند",
          "desc": "معهد تدريب متخصص لمحترفي السفر والسياحة والطيران."
        },
        "alhind_study_abroad": {
          "title": "alhind للدراسة في الخارج",
          "desc": "استشارات تعليمية خارجية للطلاب الطامحين للدراسة عالمياً."
        },
        "alhind_bus": {
          "title": "alhind Bus",
          "desc": "عمليات سفر بالحافلات الفاخرة تربط المسارات الرئيسية."
        },
        "alhind_wheels": {
          "title": "alhind Wheels",
          "desc": "خدمات تأجير السيارات والحافلات المميزة للسفر المحلي."
        },
        "avs_world": {
          "title": "AVS World",
          "desc": "خدمة معالجة التأشيرات المتخصصة لضمان التوثيق الدولي السلس."
        },
        "alhind_attestation": {
          "title": "alhind للتصديق",
          "desc": "خدمات تصديق الوثائق الموثوقة للاحتياجات القانونية والمهنية."
        },
        "alhind_charitable_foundation": {
          "title": "مؤسسة alhind الخيرية",
          "desc": "الجناح المسؤولية الاجتماعية للمجموعة، يركز على تنمية المجتمع والرعاية الاجتماعية."
        },
        "alhind_calicut_tower": {
          "title": "alhind Calicut Tower",
          "desc": "الخدمات الفندقية والضيافة الرائدة للمجموعة في كيرالا."
        },
        "alhind_aqua": {
          "title": "alhind Aqua",
          "desc": "القطاع الاستهلاكي للمجموعة، يضم علامتها التجارية الخاصة لمياه المعدنية."
        },
        "alhind_jobs": {
          "title": "alhind Jobs",
          "desc": "حلول التوظيف والتوظيف العالمية التي تربط المواهب بالفرص الدولية."
        }
      }

      
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: { escapeValue: false }
  });

export default i18n;